export default "__VITE_ASSET__7890aef8__"